import React from 'react';
import MediaPlayer from '@business/workflows/ComponentUI/MediaPlayer';
import { FullScreenModalProps } from '@business/interfaces/photo';
import { Button } from '@business/workflows/ComponentUI';
import { SVGAssets } from '@business/assets/vectors';

const FullScreenModal: React.FC<FullScreenModalProps> = ({
  isOpen,
  onClose,
  mediaType,
  mediaSrc
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black">
      {/* Close button */}
      <Button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Close"
        btnStyle="no-outline">
        <SVGAssets.CloseBtn />
      </Button>

      {/* Media content */}
      <div className="w-full h-full flex items-center justify-center p-4">
        {mediaType === 'image' ? (
          <img
            src={mediaSrc}
            alt="Full screen view"
            className="max-w-full max-h-full object-contain"
          />
        ) : (
          <MediaPlayer
            type={mediaType}
            src={mediaSrc}
            controls={true}
            muted={false}
            width="100%"
            height="100%"
            containerClassName="w-full h-full"
          />
        )}
      </div>
    </div>
  );
};

export default FullScreenModal;
